import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import MenuSearchAndFilter from './common/MenuSearchAndFilter';
import Globalize from '../actions/languages/Globalize';

const Greetings = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (props.isFeaturesLoading) return;
    if (!props?.user?.email) {
      navigate('/login?redirect=' + encodeURIComponent(location.pathname), { replace: true });
    }
  }, [props.isFeaturesLoading, props?.user?.email, navigate, location.pathname]);

  return (
    <div id="welcome-screen">
      {/* <NavigationBar loggedStatus={true} user={props.user} /> */}
      <div className="index-page">
        <h4 className="text-center margin-zero">
          {Globalize.getString('welcome_string')} <span className="text-bold text-primary">{props?.user?.email}</span>
        </h4>
        <div className="index-page-links">
          <MenuSearchAndFilter userRoles={props.user_roles} {...props} />
        </div>
      </div>
    </div>
  );
};


export default Greetings;
